<template>
  <Modal
    persistent
    :title="$t('project.add')"
    :hide-footer="!project"
    @ok="save"
    :value="value"
    :okText="$t('project.add')"
    @input="$emit('input', $event)"
  >
    <PageTitle :description="$t('project.addDescription')"></PageTitle>
    <div class="o-card__height--400">
      <project-search
        v-model="project"
        ref="projectSearch"
        clearable
        :label="$t('project.title')"
        :placeholder="$t('project.title')"
        :class="{ 'vs-invalid': validActivated && !project }"
      ></project-search>
      <div class="u-margin-top-large u-text-align-center" v-if="!project">
        <br />
        <br />
        {{ $t("common.or") }}
        <br />
        <br />

        <Button block variant="light-primary" @click="newProject()">
          {{ $t("project.add") }}
        </Button>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "../Base/Modal.vue";
import PageTitle from "@/components/Shared/PageTitle/index.vue";
import Requests from "@/services/Requests";
import ProjectSearch from "@/components/Searches/ProjectSearch.vue";
import Button from "../Base/Button.vue";
export default {
  components: {
    Modal,
    PageTitle,
    ProjectSearch,
    Button,
  },
  props: {
    value: {
      default: false,
    },
    edit: {
      default: false,
      type: Boolean,
    },
    form: {
      default: () => ({
        id: null,
        title: "",
      }),
    },
  },
  data() {
    return {
      project: null,
      validActivated: false,
    };
  },
  watch: {
    project(value) {
      this.validActivated = value ? true : false;
    },
  },

  methods: {
    newProject() {
      this.$refs.projectSearch.showCreateNewProject = true;
    },
    async save(loading) {
      console.log(this.validation(), "valid");

      if (!this.validation()) {
        return;
      }
      loading(true);
      const response = await Requests.ProjectMainProject.Create({
        projectId: this.project.id,
        mainProjectId: this.form.id,
        isActive: true,
      });
      if (response.message === "OK") {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("project.success"),
          variant: "success",
          duration: 2500,
        });
        this.$emit("refresh");
        this.$emit("input", false);
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    validation() {
      this.validActivated = true;
      if (this.project) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style></style>
